import { render } from "./ForbiddenNameTable.vue?vue&type=template&id=7094ad19"
import script from "./ForbiddenNameTable.vue?vue&type=script&lang=js"
export * from "./ForbiddenNameTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__